export default {
  C: "Dó",
  CSharp: "Dó♯",
  D: "Ré",
  DFlat: "Ré♭",
  DSharp: "Ré♯",
  E: "Mi",
  EFlat: "Mi♭",
  F: "Fá",
  FSharp: "Fá♯",
  G: "Sol",
  GFlat: "Sol♭",
  GSharp: "Sol♯",
  A: "Lá",
  AFlat: "Lá♭",
  ASharp: "Lá♯",
  B: "Si",
  BFlat: "Si♭",

  correctExcl: "Certo!",
  wrongExcl: "Errado!",

  ABORT: "CANCELAR",

  lastRound: "Ultima Ronda",
  score: "Pontuação",
  accuracy: "Precisão",
  correct: "certo",
  wrong: "errado",

  START: "INICIAR",
  settings: "Definições",
  ROUND_LENGTH: "DURAÇÃO",
  NOTE_INPUT: "INTRODUÇÃO DE NOTAS",
  CLEF: "CLAVE",
  DIFFICULTY: "DIFICULDADE",
  ACCIDENTALS: "ACIDENTES",
  LANGUAGE: "IDIOMA",
  twentySeconds: "20 s",
  oneMinute: "1 min",
  fiveMinutes: "5 min",
  infinite: "Infinito",
  buttons: "Botões",
  piano: "Piano",
  trebleClef: "Clave Sol",
  bassClef: "Clave Fá",
  altoClef: "Clave Dó",
  tenorClef: "Tenor",
  easy: "Fácil",
  normal: "Normal",
  hard: "Difícil",
  none: "Nenhum",
  sharp: "♯ (sustenido)",
  flat: "♭ (bemol)",
  sharpAndFlat: "♯ e ♭",
  SOUND: "SOM",
  VIBRATION: "VIBRAÇÃO",
  DISPLAYCORRECTNOTE: "MOSTRAR NOTA CORRETA",
  on: "Ligado",
  off: "Desligado",

  TIME: "TEMPO",
  CORRECT: "CORRETO",
  ACCURACY: "PRECISÃO",
  SCORE: "PONTUAÇÃO",

  record: "Pontuação Máxima",
  history: "Historial",

  noMidiSupport: "Desculpe, mas aparentemente o seu dispositivo não suporta MIDI.",
  noDeviceFound: "Dispositivo não encontrado. Por favor volte a conectar o dispositivo MIDI.",
  playTheNote: "Toque a nota no seu teclado MIDI.",
  lastNotePlayed: "Ultima nota tocada",
};



// WEBPACK FOOTER //
// ./src/resources/pt.js